// useServiceWorker.js
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export function useServiceWorker() {
    const history = useHistory();

    useEffect(() => {
        if (!('serviceWorker' in navigator)) return;

        let registration;

        navigator.serviceWorker
            .register('/serviceWorker.js')
            .then(reg => {
                registration = reg;

                reg.addEventListener('updatefound', () => {
                    const newWorker = reg.installing;
                    if (!newWorker) return;

                    newWorker.addEventListener('statechange', () => {
                        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                            window.location.reload();
                        }
                    });
                });

                if (reg.waiting && navigator.serviceWorker.controller) {
                    window.location.reload();
                }
            })
            .catch(err => console.error('[SW] Registration failed:', err));

        const unlisten = history.listen(() => {
            if (registration) registration.update();
        });

        return () => unlisten();
    }, [history]);
}
